/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_appsync_graphqlEndpoint": "https://qup7m3pyvvd3zomk2me3kir3eu.appsync-api.eu-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-zzqtza2k6bakxj7q2lcmqmz3p4",
    "aws_cognito_identity_pool_id": "eu-west-2:e249949f-96ea-4619-9343-f5add0b12f97",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_UPP0rFFY9",
    "aws_user_pools_web_client_id": "7otv7t55u6qnaus4uccp4acsg4",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "pp-20240920214110-hostingbucket-dev",
    "aws_content_delivery_bucket_region": "eu-west-2",
    "aws_content_delivery_url": "https://devrri2g1g5ax.cloudfront.net"
};


export default awsmobile;
